<template>
  <div class="program-settings-page"
    v-if="tabs[activeTabIndex]"
  >
    <!-- Header -->
    <div class="program-settings-page-header">
      <!-- Back -->
      <app-back-button
        route-name="subpropertySettings"
        i18n-code="subpropertySettings.menu"
      />
      <!-- Button create -->
      <div class="settings__create">
        <router-link
          :to="{ path: tabs[activeTabIndex].buttonLink }"
        >
          <el-button type="primary">
            <app-i18n :code="tabs[activeTabIndex].buttonCode" />
          </el-button>
        </router-link>
      </div>
    </div>

    <!-- Pages -->
    <app-location-list-page v-if="tabs[activeTabIndex].type === 'locations'" />
    <app-category-list-page v-else-if="tabs[activeTabIndex].type === 'categories'" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CategoryPermissions } from '@modules/category/category-permissions';

import LocationListPage from '@modules/location/components/location-list-page.vue';
import CategoryListPage from '@modules/category/components/category-list-page.vue';
import SeasonListPage from '@modules/season/components/season-list-page.vue';

export default {
  name: 'program-settings-page',

  props: {
    tabName: {
      type: String
    }
  },

  computed: {
    ...mapGetters({
      tabIndex: 'programSettings/tabIndex',
      tabs: 'programSettings/tabs',
      currentManage: 'auth/manage/currentManage',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      currentUser: 'auth/currentUser',
    }),
    hasPermissionToCreate() {
      return new CategoryPermissions(this.currentUser).create;
    },
  },

  mounted() {
    this.doResetTabs();
    this.setTabs(this.tabs);
    this.parseActiveTab();
  },

  beforeDestroy() {
    this.resetTabs();
  },

  methods: {
    ...mapActions({
      doFetchCategory: 'category/list/doFetch',
      doFetchLocation: 'location/list/doFetch',
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
      setTabIndex: 'programSettings/setTabIndex',
      doResetTabs: 'programSettings/doResetTabs',
    }),
    parseActiveTab() {
      var tabIndex = this.tabIndex; 

      if (this.tabName) {
        tabIndex = this.tabs.findIndex(({ type }) => type == this.tabName);
      }
      
      this.setTabIndex(tabIndex);
      this.setActiveTabIndex(this.tabIndex)
    },
  },
  

  components: {
    [LocationListPage.name]: LocationListPage,
    [CategoryListPage.name]: CategoryListPage,
    [SeasonListPage.name]: SeasonListPage,
  },

  watch: {
    'activeTabIndex': {
      handler: 'parseActiveTab'
    },
  },
};
</script>

<style>
.text {
  font-size: 20px;
}

.card {
  padding-bottom: 20px;
}

.clearfix {
  font-size: 24px;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.clearfix button {
  float: right;
}

.space {
  margin-right: 20px;
}

.category-name {
  margin-bottom: 18px;
  clear: both;
}

.category-name div {
  float: right;
}

.category-name div button {
  padding-left: 5px;
}

.program-settings-page-header {
  display: grid;
  grid-template-areas: "back create"
}

.settings__create {
  grid-area: create;
  justify-self: end;
}
</style>

